import React, { useEffect, useState } from 'react';
import { Fab } from '@mui/material';
import WhatsappRounded from '@mui/icons-material/WhatsappRounded';
import { useSelector } from 'react-redux';

const WhatsAppFloatingBtn = () => {
    const contacts = useSelector((state) => state.auth.contacts);
    const [isBouncing, setIsBouncing] = useState(true);

    useEffect(() => {
        // 1. Handle the notification sound
        const playSound = async () => {
            try {
                // Ensure you have a valid sound file in your public folder
                const audio = new Audio('/notification-sound.mp3');
                await audio.play();
            } catch (error) {
                // Browsers often block autoplay if the user hasn't interacted with the page yet
                console.warn('Autoplay blocked by browser policy:', error);
            }
        };

        playSound();

        // 2. Remove the animation after 3 seconds so it doesn't run again if re-rendered
        const timer = setTimeout(() => {
            setIsBouncing(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    const handleWhatsAppClick = () => {
        const supportContact = contacts.find((contact) => contact?.link?.includes('whatsapp:'));
        if (supportContact) window.open(supportContact?.link, '_blank');
    };

    return (
        <Fab
            onClick={handleWhatsAppClick}
            aria-label="support"
            sx={{
                width: 70,
                height: 70,
                position: 'fixed',
                bottom: { xs: 100, md: 32 },
                right: 24,
                zIndex: 9999,
                backgroundColor: '#FFFFFF',
                color: '#0D4CA6',
                border: '1px solid #E5E7EB',
                boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
                transition: 'all 0.3s ease',

                // Add the bounce animation conditionally
                ...(isBouncing && {
                    animation: 'bounce 1s ease-in-out 3', // 1 second duration, 3 iterations = 3 seconds
                    '@keyframes bounce': {
                        '0%, 20%, 50%, 80%, 100%': {
                            transform: 'translateY(0)'
                        },
                        '40%': {
                            transform: 'translateY(-20px)'
                        },
                        '60%': {
                            transform: 'translateY(-10px)'
                        }
                    }
                }),

                '&:hover': {
                    backgroundColor: '#F8FAFC',
                    boxShadow: '0 10px 22px rgba(0,0,0,0.16)',
                    transform: 'scale(1.05)'
                }
            }}
        >
            <WhatsappRounded color="success" sx={{ width: 40, height: 40 }} />
        </Fab>
    );
};

export default WhatsAppFloatingBtn;
